import { render, staticRenderFns } from "./UrlWrapper.vue?vue&type=template&id=09295988&scoped=true&"
import script from "./UrlWrapper.vue?vue&type=script&lang=ts&"
export * from "./UrlWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./UrlWrapper.vue?vue&type=style&index=0&id=09295988&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09295988",
  null
  
)

export default component.exports
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QScrollArea});
